import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Select from "react-select";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import RunReportNow from "./../RunReportNow";
import { ToastContainer, toast } from "react-toastify";
import Rightsidebar from "./../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import { Commonfun, removeDuplicateDate } from "./../Commonfun";
import { AppContext } from "../../../Context/Context";
import { timezonechange } from "./../Commonfun";
import { timezoneval } from "./../Commonfun";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import Loader from "./../CommonLoader";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { useMediaQuery } from "react-responsive";
import DatagridComp from "./../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import { Link, useParams } from "react-router-dom";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';


export default function Aiauditsummary() {

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [openAutoDepError, setOpenAutoDepError] = useState(false);
  const [autoDepErrorMsg, setAutoDepErrorMsg] = useState('');
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const [Domainsectiondata, SetDomainsectiondata] = useState([]);
  const [initialDateval, SetInitialDateval] = useState([]);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [analysisSummaryPlan, setanalysisSummaryPlan] = useState({
    status: false,
    error: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [markedRows, setMarkedRows] = useState({});
  const [first, setfirst] = useState({
    name: "",
    path: "",
    closeName: "Close",
    statusDomain: false,
  });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({
    domain_name: "",
    domain_url: "",
  });
  const [dEngineoption, SetdEngineoption] = useState({
    label: "Select Date",
    value: "Select Date",
  });
  const [prevdEngineoption, setprevdEngineoption] = useState({
    label: "Select Date",
    value: "Select Date",
  });
  const [faqData, setfaqData] = useState("2");
  const [datagridval, setDatagridval] = useState(1);
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const handleClose = () => {
    setOpen(false);
  };
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const [aiSuggestions, setAiSuggestions] = useState({});
  const [validation, setValidation] = useState({
    dateerror: "",
  });

  let querystring = useParams();
  let cont_audit_id = querystring.id;
  let job_audit_id = querystring.jobid;

  const checkUserPlan = async () => {
    const analysisSummaryP = await Utils("analysis_summary", ApiToken);
    if (analysisSummaryP.status) {
      callUserdataApi();
      faqdatafun();
    }
    setanalysisSummaryPlan(analysisSummaryP);
  };

  const arr = [];

  useEffect(() => {
    checkUserPlan();
  }, []);

  const handleAiReadinessClick = async (url, data, rowId) => {
    if (!url) {
      toast.error("No AI suggestion URL available", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    if (!ApiToken) {
      toast.error("Authorization token is missing or invalid. Please log in again.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      });

      if (response?.status === 401) {
        toast.error("Session expired. Please log in again.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/login"); // Redirect to login page
        return;
      }

      if (response?.data?.suggestion) {
        setAiSuggestions((prev) => ({
          ...prev,
          [rowId]: response.data.suggestion,
        }));
        toast.success("AI Suggestion loaded", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error("No suggestion found in response", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      setapiOpen(true);
      setapierrorMsg(error?.response?.data?.error)
      console.error("Error fetching AI suggestion:", error);
    } finally {
      setLoading(false);
    }
  }
  const handleMarkForDeploy = async (row) => {
    const rowKey = row.sid;
    const suggestion = aiSuggestions[row.sid] || row.ai_suggestion;
    if (!suggestion) {
      // toast.error("No suggestion available for this row. Please generate AI suggestion first.");
      setOpenAutoDepError(true);
      setAutoDepErrorMsg("No suggestion available for this row. Please generate AI suggestion first.");
      return;
    }
    if (markedRows[rowKey]) return;

    try {
      setLoading(true);
      const payload = {
        job_id: parseInt(job_audit_id),
        detail_id: parseInt(row.id),
        scan_id: row.sid || null,
        url: domainNameUrl.domain_url,
        requested_changes: row.element,
        suggestion: suggestion,
        is_updated: true,
        user_domain_id: parseInt(row.user_domain_id || esodata.domaindata.value.header_selected),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}autodeploy/update/`,
        payload,
        {
          headers: { Authorization: `${ApiToken}` },
        }
      );

      toast.success(response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });

      setMarkedRows((prev) => ({ ...prev, [rowKey]: true }));

    } catch (error) {
      console.error("Error marking for deploy:", error);
      // toast.error(error?.response?.data?.error || "API Error", {
      //   position: "top-center",
      //   autoClose: 5000,
      // });
      setOpenAutoDepError(true);
      setAutoDepErrorMsg(error?.response?.data?.error || "API Error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeployAll = async () => {
    try {
      setLoading(true);

      const userDomainId =
        esodata.domaindata.value.header_selected;

      const technology = "django";

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}autodeploy/deploy/`,
        {
          params: {
            job_id: parseInt(job_audit_id),
            user_domain_id: parseInt(userDomainId),
            technology: technology,
          },
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );

      toast.success(response?.data?.message || "Deployment started", {
        position: "top-center",
        autoClose: 3000,
      });

      console.log("Deployed URLs:", response?.data?.urls);

    } catch (error) {
      console.error("Deploy error:", error);

      toast.error(
        error?.response?.data?.message || "Deployment failed",
        {
          position: "top-center",
          autoClose: 5000,
        }
      );
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      field: "element",
      headerName: "Element",
      description: "The severity level of the issue detected.",
      minWidth: 350,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",

    },
    {
      field: "readability_score",
      headerName: "Reading Score",
      description: "The specific accessibility issue found.",
      minWidth: 110,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "calculated_grade",
      headerName: "Grade Level",
      description: "A detailed error message describing the issue.",
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "ai_readiness",
      headerName: "AI Suggestion",
      description: "SEO-optimized anchor text ideas generated by AI to improve your ranking for target keywords.",
      minWidth: 450,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        params.row.job = job_audit_id;
        params.row.id = cont_audit_id;
        console.log("params", params.row)
        const rowId = params.row.sid;
        const suggestion = aiSuggestions[rowId];
        if (suggestion) {
          return (
            <div
            >
              {suggestion}
            </div>
          );
        }

        return (
          <button
            onClick={() => handleAiReadinessClick(`${process.env.REACT_APP_API_URL}content/ai_content_suggestion/`, params.row, rowId)}
            style={{
              padding: "8px 16px",
              backgroundColor: "#ff601f",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500"
            }}
          >
            Suggestion
          </button>
        );
      }
    },
    {
      field: "action",
      headerName: "Action",
      description: "Mark row for deployment",
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const rowKey = params.row.sid;
        const isMarked = markedRows[rowKey];

        return (
          <button
            onClick={() => handleMarkForDeploy(params.row)}
            style={{
              padding: "8px 16px",
              backgroundColor: isMarked ? "#4caf50" : "#ff601f",
              color: "white",
              border: `1px solid ${isMarked ? "#4caf50" : "#ff601f"}`,
              borderRadius: "4px",
              cursor: isMarked ? "default" : "pointer",
              fontSize: "14px",
              fontWeight: "500",
            }}
            disabled={isMarked}
          >
            {isMarked ? "Marked" : "Mark for Deploy"}
          </button>
        );
      },
    }

  ];
  const rows = cardData ?? [];
  const callUserdataApi = async () => {
    setLoading(true);
    setTableLoading(true);
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}content/analysis_suggestion/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${cont_audit_id}&job_id=${job_audit_id}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });
    setDomainNameUrl({
      domain_name: datavalue?.data?.domain_name,
      domain_url: datavalue?.data?.domain_url,
    });

    console.log("adta", datavalue?.data?.table_data)
    // const dataval = datavalue?.data?.table_data;
    setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
    // var Sections = [];
    const newData = datavalue?.data?.table_data.map((obj, index) => {
      return { ...obj, sid: index + 1 };
    });

    const initialMarked = {};
    newData?.forEach((row) => {
      if (row.is_updated) {
        initialMarked[row.sid] = true;
      }
    });

    setMarkedRows(initialMarked);

    setCardData(newData);
    setLoading(false);
    setTableLoading(false);
  };


  const reportNow = async () => {
    var errs = 1;
    let errors = {};
    if (!selectval || !selectval.value) {
      errors.dateerror = "This field is required.";
      errs = 2;
    } else {
      errs = 1;
      setValidation(errors);
    }
    if (errs === 2) {
      return setValidation(errors);
    }
    setLoading(true);
    setjobidData(selectval.value);
    setIsOpen(false);
    setprevdEngineoption(dEngineoption);
    var domainsec = "";
    callUserdataApi(selectval.value, (domainsec = ""));
  };
  function openModal() {
    setfaqData(2);
    setToggle(false);
    setIsOpen(true);
  }
  function closeModal() {
    setSelectval("");
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }
  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}content/analysis_suggestion/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${cont_audit_id}&job_id=${job_audit_id}&is_format=pdf&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(
          "AnalysisSummary",
          "pdf",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;

        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404 ||
          response?.status == 502
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloading(false);
  };
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}content/analysis_suggestion/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${cont_audit_id}&job_id=${job_audit_id}&is_format=csv&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const now = new Date();
        const datetimeval = now.toLocaleDateString();
        const hours = now.getHours().toString().padStart(2, "0");
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const seconds = now.getSeconds().toString().padStart(2, "0");
        var filedata = await Commonfun(
          "AnalysisSummary",
          "csv",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;

        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404 ||
          response?.status == 502
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  };
  const [RunReportPopShow, SetRunReportPopShow] = useState(false);
  const [RunReportType, SetRunReportType] = useState("analysis_summary");
  const [toggle, setToggle] = useState(false);
  const wrapperRef = useRef(null);
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=11`;

    try {
      const doaminsectiondatavalue = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };





  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);


  };


  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }


  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const SwitchMenu = (e) => {
    // const Id = e.target.getAttribute('data-id')
    // const Name = e.target.getAttribute('data-name')
    // SetCurrentMenu(Id)
    // SetCurrentMenuName(Name)
    // faqdatafun(Name)
  }
  return (
    <div
      className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Analysis Summary Detail Report</title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {loading === true ? <Loader /> : null}


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Analysis Summary Detail Report
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Content' },
                      { title: 'Analysis Summary', activeColor: true, link: '/analysis-summary' },
                      { title: 'Analysis Summary Detail', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid" justifyContent="space-between">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item>
              <button
                onClick={handleDeployAll}
                type="button"
                data-id="deploy_now"
                data-name="Deploy Now"
                className="trendy-tab active"
              >
                Deploy Now
                <svg
                  style={{ marginLeft: "8px" }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="22" y1="2" x2="11" y2="13"></line>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                </svg>
              </button>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  <Link to={`/content-detail/${cont_audit_id}/${job_audit_id}`}>
                    <button
                      type="button"
                      data-id="overall_content_analysis"
                      data-name="Overall Content Analysis"
                      className="trendy-tab"
                    >
                      Overall Content Analysis
                    </button>
                  </Link>

                  <Link to="#">
                    <button
                      type="button"
                      data-id="ai_suggestion"
                      data-name="AI Suggestion"
                      className="trendy-tab active"
                    >
                      AI Suggestion
                    </button>
                  </Link>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container table-search-break">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap table-100-height">
                {analysisSummaryPlan.status ? (
                  <DatagridComp
                    className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows || []}
                    getRowId={(row) => row.sid}
                    autoheightval={autoheightval}
                    datagridval={datagridval}
                    columnFreezeWidth={[0, 320]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                  />
                ) : (
                  <Freeaudit planStatus={analysisSummaryPlan} />
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <div className="">
        <div className="">
          {toggle && (
            <Rightsidebar
              close={() => setToggle(false)}
              setToggle={setToggle}
              initialfaqDateval={initialfaqDateval}
            />
          )}
        </div>
        <Dialog
          open={modalIsOpen}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="competitor_test_filter job_date_filter over_all_accessibility"
        >
          <DialogTitle className="keyword-dialog-header ">
            {"Filter By"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">
                <div>
                  <div >
                    <div>
                      <span className="select_filter_text">Completed Date</span>
                      <Select
                        value={dEngineoption}
                        options={completedate}
                        placeholder="Select..."
                        labelField="completed_at"
                        valueField="id"
                        onChange={(values) => {
                          setSelectval(values);
                          SetdEngineoption(values);
                        }}
                        styles={customDropdownStyles()}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </div>

                  <div className="col">
                    <span className="text-error">{validation.dateerror}</span>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <button
              className="form_submit_btn"
              onClick={reportNow}
              style={{ cursor: "pointer" }}
            >
              Submit
            </button>
            <button style={{ cursor: "pointer" }} onClick={closeModal}>
              close
            </button>
            <button
              className="form_submit_btn"
              style={{ cursor: "pointer" }}
              onClick={handleReset}
            >
              Reset
            </button>
          </DialogActions>
        </Dialog>

        {!openCommonAlerts && (
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle className="keyword-dialog-header">
              {"Error Message "}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                No Data Found
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action-button">
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        )}
        {!openCommonAlerts && (
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        )}
        <Dialog
          open={openAutoDepError}
          onClose={() => setOpenAutoDepError(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className="keyword-dialog-header">
            {"Warning Message "} <ReportProblemIcon fontSize="large" sx={{ color: '#ff601f' }} />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {autoDepErrorMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button onClick={() => setOpenAutoDepError(false)}>Close</Button>
            <Button onClick={() => navigate('/auto-deployment-settings')}>Auto Deploy</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={checkD}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="domain-verify-alert"
        >
          <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "15px",
                  lineHeight: "1px",
                  width: "max-content",
                }}
              >
                <p>{`Please verify your domain ${domainNameUrl.domain_name} to access these features`}</p>
                <a href={domainNameUrl.domain_url}>
                  {domainNameUrl.domain_url}
                </a>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button
              onClick={() => {
                navigate(first.path);
              }}
            >
              {first.name}
            </Button>
            <Button onClick={() => setcheckD(false)}>{first.closeName}</Button>
          </DialogActions>
        </Dialog>
      </div>

      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
        isDomainSection={true}
      />
      <UserActivityTracker pagename="Content - Analysis Summary" />
    </div >
  );
}
